import { post } from '../api';

const route = '/auth/sign_in';

const postSignIn = ({ data, config }) => post(route, data, config);

export default postSignIn;
